import SearchIcon from "@mui/icons-material/Search";
import { Box, Button as MuiButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import jwt_token from "jwt-decode";
import {
    useEffect,
    useLayoutEffect,
    useRef,
    useState,
} from "react";
import { Alert, Button, Col, Container, Row } from "react-bootstrap";
import { BsChatRightTextFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { format_currency_2 } from "../../common/format";
import ListComp2, { ButtonBodyTable } from "../../common/listcomp2";
import {
    ListView,
    ListViewHeader,
    ListViewInfo
} from "../../common/listview";
import SearchComp from "../../common/searchcomp";
import T from "../../common/traducao";
import NewAlertError from "../../components/ui_comp/Alerts/views.alert.error";
import ModalCancelarOrcamento from "../../components/ui_comp/Modals/ModalCancelar";
import ModalDelete from "../../components/ui_comp/Modals/ModalDelete";
import ModalDuplicarOrcamento from "../../components/ui_comp/Modals/ModalDuplicarOrcamentoControl";
import ModalGerarPedido from "../../components/ui_comp/Modals/ModalGeraPedidoControl";
import ModalImprimir from "../../components/ui_comp/Modals/ModalPrintOut";
import NewImprimirOrcamento from "../../components/ui_comp/Modals/ModalPrintOut/ImprimirOrcamentoControl";
import ModalSolicitarPedido from "../../components/ui_comp/Modals/ModalSolicitaPedidoControl";
import {
    GetPermissaoEditar,
    GetPermissaoExcluir,
    GetPermissaoInserir,
    GetPermissaoVisualizar,
    getFiltro,
    getToken,
    setFiltro,
} from "../../config/localstorageConfig/localstorage";
import orcamentovendaService from "../../services/service.orcamentovenda";
import "../../styles/botoesfiltrosrapidos.css";

const OrcamentoVendaList = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [orcamentosVenda, setOrcamentosVenda] = useState();
    const [pages, setPages] = useState();
    const [records, setRecords] = useState();
    const [filterstate, setFilterState] = useState();
    const [permiteConsultarStatus, setPermiteConsultarStatus] = useState(false);
    const [modalExcluir, setModalExcluir] = useState(false);
    const [modalImprimir, setModalImprimir] = useState(false);
    const [modalDuplicar, setModalDuplicar] = useState(false);
    const [modalGerarPedido, setModalGerarPedido] = useState(false);
    const [modalSolicitarPedido, setModalSolicitarPedido] = useState(false);
    const [modalCancelarOrcamento, setModalCancelarOrcamento] = useState(false);
    const [IndexOrcamentoSelecionado, setIndexOrcamentoSelecionado] = useState();
    const [IndexDeletarOrcamento, setIndexDeletarOrcamento] = useState();
    const [IndexImprimirOrcamento, setIndexImprimirOrcamento] = useState();
    const [IndexDuplicarOrcamento, setIndexDuplicarOrcamento] = useState();
    const [IndexGerarPedido, setIndexGerarPedido] = useState();
    const [IndexCancelarOrcamento, setIndexCancelarOrcamento] = useState();
    const [IndexSolicitarPedido, setIndexSolicitarPedido] = useState();
    //const token = Cookies.get(TOKEN_KEY);
    const ordertype = useRef();
    const orderField = useRef();

    const [permiteVisualizar, setPermiteVisualizar] = useState(false);
    const [permiteEditar, setPermiteEditar] = useState(false);
    const [permiteExcluir, setPermiteExcluir] = useState(false);
    const [permiteInserir, setPermiteInserir] = useState(false);

    const [redirect, setRedirect] = useState();

    const constantes = T();
    const navigate = useNavigate();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const columns = [
        {
            field: "Id",
            headerName: "Id",
            width: 90,
            key: true,
        },
        {
            field: "DataCadastro",
            headerName: "Data Cadastro",
            width: 90,
            type: "date",
            format: "dd/MM/yyyyy",
        },
        {
            field: "DataPrevisaoFaturamento",
            headerName: "Data Previsão",
            width: 90,
            type: "date",
            format: "dd/MM/yyyyy",
        },
        {
            field: "DataValidade",
            headerName: "Data Validade",
            width: 90,
            type: "date",
            format: "dd/MM/yyyy",
        },
        {
            field: "CpfCnpjCliente",
            headerName: "CNPJ / CPF",
            width: 150,
        },
        {
            field: "NomeCliente",
            headerName: "Nome",
            width: 150,
        },
        {
            field: "ValorTotal",
            headerName: "Valor",
            width: 150,
            digits: 2,

        },
        {
            field: "Situacao",
            headerName: "Situação",
            width: 150,
            type: "custom",
            onGetCustom: (item) => {
                const style = getStyle(item);
                return <Button style={style}>{item}</Button>;
            },
        },

    ];

    const columnsFilter = [
        {
            field: "Id",
            headerName: constantes.Numero,
            tipo: "number",
        },
        {
            field: "CodCliente",
            headerName: constantes.CodigoCliente,
            tipo: "number",
        },
        {
            field: "NomeCliente",
            headerName: constantes.Cliente,
            tipo: "text",
        },
        {
            field: "ObservacaoUsuario",
            headerName: constantes.ObsUsuario,
            tipo: "text",
        },
    ];




    useEffect(() => {
        redirect && navigate(`/${redirect}`);
    }, [redirect]);

    useLayoutEffect(() => {
        // try {
        const token_salvo = getToken();
        if (token_salvo) {
            const token = jwt_token(token_salvo);
            setPermiteConsultarStatus(!token?.VisualizarApenasOrcamentoRascunho);

            const filter = GetSavedFilter() ?? {
                situacao: "Rascunho",
                campo: null,
                operacao: null,
                valor: null,
            };
            orderField.current = filter.campoorder;
            ordertype.current = filter.tipoorder;
            getOrcamentos(filter);

            setPermiteVisualizar(GetPermissaoVisualizar("orcamentovenda"));
            setPermiteEditar(GetPermissaoEditar("orcamentovenda"));
            setPermiteExcluir(GetPermissaoExcluir("orcamentovenda"));
            setPermiteInserir(GetPermissaoInserir("orcamentovenda"));
        } else {
            setRedirect('logout');
        }
    }, []);

    function getIdOrcamento(index) {
        return orcamentosVenda && orcamentosVenda[index]?.Id;
    }

    useEffect(() => {
        const id = getIdOrcamento(IndexOrcamentoSelecionado);
        id && navigate(`/orcamentosvenda/${id}`);
    }, [IndexOrcamentoSelecionado]);

    // useEffect(() => {
    //     const id = getIdOrcamento(IndexDuplicarOrcamento);
    //     id && navigate(`/orcamentosvenda/duplicar/${id}`);
    // }, [IndexDuplicarOrcamento]);

    async function deletarOrcamento(id) {
        setModalExcluir(false);
        await orcamentovendaService
            .delete(id)
            .then((response) => {
                getOrcamentos(filterstate);
                toast.success(`Orçamento ${id} deletado com sucesso`)
            })
            .catch((error) => {
                const _error =
                    error.code === "ERR_NETWORK"
                        ? "Server OffLine"
                        : error.response && error.response.data && error.response.data.error
                            ? error.response.data.error.message
                            : error.message;
                setError(_error);
            })
            .finally(() => { });
    }

    async function cancelarOrcamento(id, cancelamento) {

        await orcamentovendaService
            .Cancelar(id, cancelamento)
            .then((response) => {
                getOrcamentos(filterstate);
                setModalCancelarOrcamento(false);
                toast.success(`Orçamento ${id} cancelado com sucesso`)
            })
            .catch((error) => {
                const _error =
                    error.code === "ERR_NETWORK"
                        ? "Server OffLine"
                        : error.response && error.response.data && error.response.data.error
                            ? error.response.data.error.message
                            : error.message;
                toast.error(_error);
            })
            .finally(() => { });
    }

    async function ImprimirOrcamento(link) {
        setModalImprimir(false);
        await orcamentovendaService
            .imprimir(link)
            .then((response) => {

            })
            .catch((error) => {
                const _error =
                    error.code === "ERR_NETWORK"
                        ? "Server OffLine"
                        : error.response && error.response.data && error.response.data.error
                            ? error.response.data.error.message
                            : error.message;
                setError(_error);
            })
            .finally(() => { });
    }

    async function GerarPedido(id) {
        setModalGerarPedido(false);
        getOrcamentos(filterstate);

    }

    async function DuplicarOrcamento(id) {
        setModalDuplicar(false);
        // getOrcamentos(filterstate);

    }

    async function SolcitarPedido(id) {
        setModalSolicitarPedido(false);
        getOrcamentos(filterstate);

    }

    const btns = [
        {
            href: "/orcamentosvenda/",
            text: "Editar",
            isVisible: (arg) => {
                return permiteEditar && (arg.Situacao === "Rascunho" || arg.Situacao === "Pré-pedido");
            },
            onClick: (e) => {
                setIndexOrcamentoSelecionado(e.target.attributes.value.value);
            },
        },
        {
            href: "/orcamentosvenda/del",
            text: "Deletar",
            variant: "danger",
            isVisible: (arg) => {
                return permiteExcluir && arg.Situacao === "Rascunho";
            },
            onClick: (e) => {
                setIndexDeletarOrcamento(e.target.attributes.value.value);
                setModalExcluir(true);
            },
        },
        ,
        {
            href: "/orcamentosvenda/cancelar",
            text: "Cancelar",
            isVisible: (arg) => {
                return ((arg.Situacao === "Rascunho") || (arg.Situacao === "Bloqueado") || (arg.Situacao === "Liberado" || (arg.Situacao === "Pré-pedido")));
            },
            onClick: (e) => {
                setIndexCancelarOrcamento(e.target.attributes.value.value);
                setModalCancelarOrcamento(true);
            },
        },
        {
            href: "/orcamentosvenda/imprimir",
            text: "Imprimir",
            isVisible: (arg) => {
                return arg.Situacao !== "Cancelado";
            },
            onClick: (e) => {
                setIndexImprimirOrcamento(e.target.attributes.value.value);
                setModalImprimir(true);
            },
        },
        {
            href: "/orcamentosvenda/duplicar",
            text: "Duplicar",
            isVisible: (arg) => {
                return arg.Situacao !== "Cancelado";
            },
            onClick: (e) => {
                setIndexDuplicarOrcamento(e.target.attributes.value.value);
                setModalDuplicar(true);
            },
        },
        {
            href: "/orcamentosvenda/gerarpedido",
            text: "Gerar Pedido",
            isVisible: (arg) => {
                return arg.Situacao === "Pré-pedido" || arg.Situacao === "Liberado";
            },
            onClick: (e) => {
                setIndexGerarPedido(e.target.attributes.value.value);
                setModalGerarPedido(true);
            },
        },
        {
            href: "/orcamentosvenda/solicitarpedido",
            text: "Gerar Pré-Pedido",
            isVisible: (arg) => {
                return arg.Situacao === "Liberado";
            },
            onClick: (e) => {
                setIndexSolicitarPedido(e.target.attributes.value.value);
                setModalSolicitarPedido(true);
            },
        },
        {
            href: "/orcamentosvenda/",
            text: "Visualizar",
            isVisible: (arg) => {
                return permiteVisualizar && arg.Situacao !== "Rascunho";
            },
            onClick: (e) => {
                setIndexOrcamentoSelecionado(e.target.attributes.value.value);
            },
        },
    ];

    function GetSavedFilter() {
        const filtro = getFiltro("ORCAMENTOS");

        return filtro;

    }

    function getOrcamentos(filter) {
        setError(null);
        setLoading(true);
        setFiltro("ORCAMENTOS", filter);
        orcamentovendaService
            .getAll(filter)
            .then((response) => {
                setOrcamentosVenda(response.data.value);
                setPages(response.data.pages);
                setRecords(response.data.registros);
                setFilterState(filter);
            })
            .catch((error) => {
                const _error =
                    error.code === "ERR_NETWORK"
                        ? "Server OffLine"
                        : error.response && error.response.data && error.response.data.error
                            ? error.response.data.error.message
                            : error.message;
                setError(_error);

                error.code === "ERR_NETWORK" && navigate("/logout");

            })
            .finally(() => {
                setLoading(false);
            });
    }

    function onSearchTitle(searchValue, searchField, serachFilter) {
        let filter = {
            situacao: null,
            campo: searchField,
            operacao: serachFilter,
            valor: searchValue,
            campoorder: orderField.current,
            tipoorder: ordertype.current,
        };

        getOrcamentos(filter);
    }

    function getSearchView() {
        return permiteVisualizar ? (
            <SearchComp
                hasBotao={permiteInserir}
                to="/orcamentosvenda/New"
                botaoDisabilitado={loading}
                title={constantes.OrcamentosDeVenda}
                campos={columnsFilter}
                onSearch={(values) => {
                    onSearchTitle(
                        values.searchValue,
                        values.searchField,
                        values.searchoperator
                    );
                }}
                renderButton={({ disabled }) => (
                    <MuiButton
                        type="submit"
                        fullWidth
                        disabled={disabled}
                        startIcon={<SearchIcon />}
                        sx={{
                            backgroundColor: "#009180",
                            color: "white",
                            fontWeight: "bold",
                            textTransform: "none",
                            fontSize: "0.875rem",
                            height: "2.3rem",
                            borderRadius: "5px",
                            "&:hover": { backgroundColor: "#006e62" },
                            "&.Mui-disabled": { backgroundColor: "#ccc", color: "#666" },
                        }}
                    >
                        {constantes.Buscar}
                    </MuiButton>
                )}
            />
        ) : null;
    }

    function btnSituacaoOnClick(event) {
        let filter = {
            situacao: event.target.attributes.situacao.value,
            campo: null,
            operacao: null,
            valor: null,
            campoorder: orderField.current,
            tipoorder: ordertype.current,
        };

        getOrcamentos(filter);
    }

    function getStyle(Situacao) {
        if (Situacao === "Rascunho") {
            return { background: "#FFFFB0", color: "black" };
        } else if (Situacao === "Bloqueado") {
            return { background: "#B1D8D8", color: "black" };
        } else if (Situacao === "Liberado") {
            return { background: "#fff", color: "black" };
        } else if (Situacao === "Pré-pedido") {
            return { background: "#399E5A", color: "white" };
        } else if (Situacao === "Finalizado") {
            return { background: "#98C4F3", color: "black" };
        } else if (Situacao === "Cancelado") {
            return { background: "#FFBFBF", color: "black" };
        }
        return null;
    }

    function OrderChange(field, type) {
        orderField.current = field;
        ordertype.current = type;

        let filter = {
            ...filterstate,
            campoorder: field,
            tipoorder: type,
        };
        getOrcamentos(filter);
    }

    function getFilterSituacao() {
        return (
            <Container>
                {permiteConsultarStatus && (
                    <Row className="d-flex justify-content-center gap-0">
                        <Col xs={12} md={2}>
                            <Button
                                className="w-100"
                                style={getStyle("Rascunho")}
                                variant="primary"
                                disabled={loading}
                                onClick={btnSituacaoOnClick}
                                situacao="Rascunho"
                            >
                                {constantes.Rascunho}
                            </Button>
                        </Col>
                        <Col xs={12} md={2}>
                            <Button
                                className="w-100"
                                style={getStyle("Bloqueado")}
                                disabled={loading}
                                onClick={btnSituacaoOnClick}
                                situacao="Bloqueado"
                            >
                                {constantes.Bloqueado}
                            </Button>
                        </Col>
                        <Col xs={12} md={2}>
                            <Button
                                className="w-100"
                                style={getStyle("Liberado")}
                                disabled={loading}
                                onClick={btnSituacaoOnClick}
                                situacao="Liberado"
                            >
                                {constantes.Liberado}
                            </Button>
                        </Col>
                        <Col xs={12} md={2}>
                            <Button
                                className="w-100"
                                style={getStyle("Pré-pedido")}
                                disabled={loading}
                                onClick={btnSituacaoOnClick}
                                situacao="Pré-pedido"
                            >
                                {constantes.PrePedido}
                            </Button>
                        </Col>
                        <Col xs={12} md={2}>
                            <Button
                                className="w-100"
                                style={getStyle("Finalizado")}
                                disabled={loading}
                                onClick={btnSituacaoOnClick}
                                situacao="Finalizado"
                            >
                                {constantes.Finalizado}
                            </Button>
                        </Col>
                        <Col xs={12} md={2}>
                            <Button
                                style={getStyle("Cancelado")}
                                className="w-100"
                                disabled={loading}
                                onClick={btnSituacaoOnClick}
                                situacao="Cancelado"
                            >
                                {constantes.Cancelado}
                            </Button>
                        </Col>
                    </Row>
                )}
            </Container>
        );
    }

    function onPageSelect(number) {
        let filter = filterstate;
        filter.page = number;

        getOrcamentos(filter);
    }

    function getListView() {
        if (!orcamentosVenda?.length) {
            return (
                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        height: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "10rem 0",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: {
                                xs: "0.8rem",
                                sm: "1rem",
                                md: "1rem",
                                lg: "1rem",
                                xl: "1.2rem",
                            },
                            color: "#919191",
                            fontWeight: "bold",
                            textAlign: "center",
                        }}
                    >
                        {constantes.MsgFiltroNaoEncontradoOrcamentos}
                    </Typography>
                </Box>
            );
        }

        if (isMobile) {
            return getMobileListView();
        }

        return (
            <>
                <ListComp2
                    data={orcamentosVenda}
                    pages={pages}
                    records={records}
                    columns={columns}
                    btntype={"dropdown"}
                    msgAviso={true}
                    onPageSelect={(number) => onPageSelect(number)}
                    sortname={orderField.current}
                    sorttype={ordertype.current}
                    onSortSelect={(item, sorttype) => {
                        if (sorttype === "sort") {
                            OrderChange(null, null);
                        } else {
                            OrderChange(item, sorttype);
                        }
                    }}
                    buttons={btns}
                    striped={false}
                    noselect
                />
            </>
        );
    }

    function getMobileListView() {
        return (
            <ListView
                data={orcamentosVenda}
                headerStyle={(orcamentoVenda) => getStyle(orcamentoVenda.Situacao)}
                buttons={btns}
                pages={pages}
                records={records}
                onPageSelect={onPageSelect}
                renderHeader={(item) => (
                    <>
                        <ListViewHeader
                            text={item.Situacao}
                            variant="body2"
                        />
                        <ListViewHeader
                            label="Número"
                            text={item.Id}
                            variant="body2"
                        />
                        <ListViewHeader
                            text={item.NomeCliente}
                            sx={{ fontSize: "12px" }}
                            variant="body2"
                        />
                    </>
                )}
                renderInfo={(item) => (
                    <>
                        <ListViewInfo
                            label="Data Cadastro"
                            text={new Date(item.DataCadastro).toLocaleDateString(
                                "pt-BR",
                                { timeZone: "UTC" }
                            )}
                            variant="body2"
                        />
                        <ListViewInfo
                            label="Data Previsão"
                            text={new Date(item.DataPrevisaoFaturamento).toLocaleDateString(
                                "pt-BR",
                                { timeZone: "UTC" }
                            )}
                            variant="body2"
                        />
                        <ListViewInfo
                            label="Data Validade"
                            text={new Date(item.DataValidade).toLocaleDateString(
                                "pt-BR",
                                { timeZone: "UTC" }
                            )}
                            variant="body2"
                        />
                        <ListViewInfo
                            label="Valor"
                            text={format_currency_2.format(item.ValorTotal)}
                        />
                    </>
                )}
                renderActions={(item, index) => (
                    <ButtonBodyTable fullWidth itemdata={item} indexlinha={index} buttons={btns} btntype={"dropdown"} />
                )}
            />
        );
    }

    if (!permiteVisualizar) {
        return (
            <>
                <Container>
                    <Alert variant="danger">
                        <Alert.Heading>{constantes.Permissao}</Alert.Heading>
                        <p>{constantes.Msgsempermissao}</p>
                    </Alert>
                </Container>
            </>
        );
    }

    return (
        <Container fluid className="my-3">
            <NewAlertError error={error} onClose={() => setError(null)} />

            <ModalDelete
                constantes={constantes}
                id={getIdOrcamento(IndexDeletarOrcamento)}
                open={modalExcluir}
                close={() => {
                    setModalExcluir(false);
                }}
                onExcluir={(id) => {
                    deletarOrcamento(id);
                }}
            >
                <Typography sx={{ fontSize: 20 }}>
                    {" "}
                    <BsChatRightTextFill
                        style={{ marginBottom: "2px", marginRight: "8px" }}
                    />
                    {constantes.MsgDesejaRealmenteExcluir} {getIdOrcamento(IndexDeletarOrcamento)}
                </Typography>

            </ModalDelete>

            <ModalImprimir
                constantes={constantes}
                open={modalImprimir}
                close={() => {
                    setModalImprimir(false);
                }}
                onImprimir={(link) => {
                    ImprimirOrcamento(link);
                }}
            >
                <NewImprimirOrcamento id={getIdOrcamento(IndexImprimirOrcamento)} />
            </ModalImprimir>
            <ModalCancelarOrcamento
                id={getIdOrcamento(IndexCancelarOrcamento)}
                constantes={constantes}
                open={modalCancelarOrcamento}
                close={() => {
                    setModalCancelarOrcamento(false);
                }}
                onCancelar={(id, item) => {
                    cancelarOrcamento(id, item);
                }}
            >

            </ModalCancelarOrcamento>
            <ModalGerarPedido
                id={getIdOrcamento(IndexGerarPedido)}
                modal={modalGerarPedido}
                toggle={() => {
                    setModalGerarPedido(false);
                }}
                onGerarPedido={(id) => {
                    GerarPedido(id);
                }}
            />
            <ModalSolicitarPedido
                id={getIdOrcamento(IndexSolicitarPedido)}
                modal={modalSolicitarPedido}
                toggle={() => {
                    setModalSolicitarPedido(false);
                }}
                onSolicitarPedido={(id) => {
                    console.log('Pedido Solicitado')
                    getOrcamentos(filterstate);
                    // SolicitarPedido(id);
                }}
            />
            <ModalDuplicarOrcamento
                id={getIdOrcamento(IndexDuplicarOrcamento)}
                modal={modalDuplicar}
                toggle={() => {
                    setModalDuplicar(false);
                }}
                onDuplicar={(id) => {
                    DuplicarOrcamento(id);
                }}
            />

            {/* <Card>
                    <Card.Header>{getSearchView()}</Card.Header>
                    <Card.Body>
                        <blockquote className="blockquote mb-0">
                            {getFilterSituacao()}
                        </blockquote>
                    </Card.Body>
                </Card>
                {getListView()} */}

            <Container fluid className="my-3">
                {getSearchView()}
            </Container>
            <Container fluid className="my-3">
                {getFilterSituacao()}
            </Container>
            <Container fluid className="my-3">
                {getListView()}
            </Container>
        </Container>
    );
};

export default OrcamentoVendaList;
